import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"

export class KVKRepository {
  public async searchByName(name: string) {
    const path = "external/kvk/v2/zoeken"
    const response = await new HTTPRequestBuilder(HTTPMethods.GET, path)
      .setExpectedStatusCode(200)
      // 404 is a valid response for this endpoint, so we need to handle it.
      .addStatusCodeHandlers([{ statusCode: 404, callback: () => true }])
      .query({ resultatenPerPagina: 100, naam: name })
      .withSession(false)
      .build()
      .execute()

    return response.data
  }

  public async getEstablishmentDetails(establishmentNumber: string) {
    const path = `external/kvk/v1/vestigingsprofielen/${establishmentNumber}`
    const response = await new HTTPRequestBuilder(HTTPMethods.GET, path)
      .setExpectedStatusCode(200)
      .withSession(false)
      .build()
      .execute()

    return response.data
  }
}
